import { Component, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, LoadingController, Events, AlertController } from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { ToastHelperProvider } from '../../providers/toast-helper/toast-helper';
// import { QrHelperProvider } from '../../providers/qr-helper/qr-helper';

import { IntervalObservable } from "rxjs/observable/IntervalObservable";
import 'rxjs/add/operator/filter';

/**
 * Generated class for the StatusDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-status-detail',
  templateUrl: 'status-detail.html',
})
export class StatusDetailPage {

  public lotData;
  public readyForPickup = false;
  public errors = [];
  private scanSub: any ;
  public loading;
  public errorMessage;
  public hideContent = false;
  public init: boolean = true;
  public scanEventName = 'clientStatusCode:scanned';
  public _scanEventFunction;
  public lotId;
  public failedRequest:boolean = false;
  public watchObs:boolean = false;
  public subscribed:boolean = false;
  public spinnerTime:any = null;

  constructor(public navCtrl: NavController, 
              public navParams: NavParams,
              public viewCtrl: ViewController,
              public loadingCtrl: LoadingController,
              private rest: RestProvider,
              public events: Events,
              private chRef: ChangeDetectorRef,
              private alertCtrl: AlertController,
              private toastHelper: ToastHelperProvider
              ) {
    //comment user scan import to constructor
    // private qrHelper: QrHelperProvider,

    this.lotId = this.navParams.get('lotId');
    this.showLoading('Ophalen van lot...');
    this.getLotData();
  }

  ionViewWillEnter(){
    this.watchObs = true;
    //comment user scan
    // this._scanEventFunction = text => {this.codeFound(text);}
    // this.events.subscribe(this.scanEventName, this._scanEventFunction);
    if (!this.init) {
      this.getLotData();
    }
    this.init = false;
  }

  ionViewWillLeave(){
    this.watchObs = false;
    //comment user scan
    // this.events.unsubscribe(this.scanEventName, this._scanEventFunction);
    // this.qrHelper.destroyQr();
  }

  getLotData() {
    if (!this.rest.checkConnection()) {
      this.presentNoConnectionAlert(this.getLotData);
      return;
    }
    this.rest.getLot(this.lotId).subscribe((lot) => this.processObservable(lot), error => {
      this.hideLoading();
      this.failedRequest = true;
      this.toastHelper.showToast('ERROR: Kon de lot data niet ophalen.', 'error');
    });
    if (!this.subscribed) {
      this.subscribed = true;
      IntervalObservable.create(5000)
        .filter(() => this.watchObs) // only fires when component is watchObs
        .subscribe(() => {
          this.spinnerTime = performance.now();
          this.updateLoadingSpinner(true);
          this.rest.getLot(this.lotId)
            .subscribe(lot => this.processObservable(lot), error => this.toastHelper.showToast('ERROR: Kon de lot data niet updaten.', 'error'));
        });
    }
  }

  processObservable(lot){
    if (lot) {
      this.lotData = JSON.parse(String(lot));
      if (this.lotData.originalLot) {
        this.lotData.nr = this.lotData.originalLot.nr;
        this.lotData.id = this.lotData.originalLot.id;
        this.lotData.pickedUp = this.lotData.originalLot.pickedUp;
        if (this.lotData.originalLot.imgs.length > 0) {
          this.lotData.imgs = this.lotData.originalLot.imgs;
        }
      }
      console.log(this.lotData);
      this.validateData();
      this.hideLoading();
      this.failedRequest = false;
    }else{
      this.hideLoading();
      this.failedRequest = true;
      this.toastHelper.showToast('ERROR: Kon de lot data niet ophalen.', 'error');
    }
    this.updateLoadingSpinner(false);
  }
  
  validateData(){
    this.errors = [];
    if (this.lotData.price == '0.00') {
      this.errors.push('De prijs staat op 0.00€');
    }
    if (this.lotData.buyerId == null) {
      this.errors.push('Er is geen koper gekoppeld aan dit lot');
    }
    if (!this.lotData.paid) {
      this.errors.push('Dit lot is nog niet betaald');
    }
    if (this.errors.length == 0) {
      this.readyForPickup = true;
    }else{
      this.readyForPickup = false;
    }
  }

  dismiss() {
    this.navCtrl.pop();
  }

  //commented klant scan voor afhaling + commented qr import (import { QrHelperProvider } from '../../providers/qr-helper/qr-helper';) + on ionViewWillLeave line ()

  // scanBuyer(){
  //   this.hideContent = true;
  //   if (!this.chRef['destroyed']) {
  //       this.chRef.detectChanges();
  //   }
  //   this.qrHelper.showCamera();
  //   this.qrHelper.startQr(this.scanEventName);
  // }

  // codeFound(text:string) {
  //   this.hideContent = false;
  //   if (!this.chRef['destroyed']) {
  //       this.chRef.detectChanges();
  //   }
  // if uncommented implement logic to decode the qrcode hash first
  // let qrObj = JSON.parse(text);
  //   if (typeof(qrObj) === 'object' && 'section' in qrObj) {
  //       if(qrObj['section'] == 'contacts'){
  //         if ('entryId' in qrObj) {
  //           if (this.lotData.buyerId == qrObj['entryId']) {
  //             this.toastHelper.showToast('Koper komt overeen.');
  //             this.presentConfirm();
  //           }else{
  //             this.toastHelper.showToast('Gescande QR code is van een andere klant.', 'error');
  //           }
  //         }else{
  //           this.toastHelper.showToast('ERROR: Kon de user niet afleiden uit de qr code.', 'error');
  //         }
  //       }else{
  //         this.toastHelper.showToast('ERROR: QR code is niet van een klant maar van: ' + qrObj['section'] + '.', 'error');
  //       }
  //   }else{
  //     this.toastHelper.showToast('ERROR: Onbekende QR code.', 'error');
  //   }
  // }

  setPickedUp(value){
    if (!this.rest.checkConnection()) {
      this.presentNoConnectionAlert(this.setPickedUp.bind(this, value));
      return;
    }
    if (!value) {
      this.watchObs = false;
      let alert = this.alertCtrl.create({
        title: 'Annuleer afgehaald',
        message: 'Weet je zeker dat je de status afgehaald wilt ongedaan maken?',
        buttons: [
          {
            text: 'Annuleren',
            role: 'cancel',
            handler: () => { 
              this.toastHelper.showToast('Status is ongewijzigd.'); 
              this.watchObs = true;
            }
          },
          {
            text: 'Bevestigen',
            handler: () => { 
              this.sendPickedUp(value); 
              this.watchObs = true; 
            }
          }
        ]
      });
      alert.present();
    }else{
      this.sendPickedUp(value)
    }
  }

  sendPickedUp(value){
    this.showLoading('Bezig met status afgeleverd opslaan');
    
    this.rest.setPickedUpStatus(this.lotData.id, value).subscribe((success) => {
      this.hideLoading();
      if (success) {
        this.toastHelper.showToast('Status afgeleverd opgeslagen.');
        this.updatePickedUp(value);
      }else{
        this.toastHelper.showToast('ERROR: Kon de status niet op afgeleverd zetten.', 'error');
      }
    }, error => {
      this.hideLoading();
      this.toastHelper.showToast('ERROR: Fout tijdens het versturen naar de server.', 'error');
    });
  }

  updatePickedUp(value){
    this.lotData.pickedUp = value;
    if (!this.chRef['destroyed']) {
        this.chRef.detectChanges();
    }
  }

  updateLoadingSpinner(show){
    let spinner = document.querySelector('page-status-detail .loading-spinner');
    if (show) {
      if(!spinner.classList.contains('active')){
        spinner.classList.add('active');
      }
    }else{
      let timeSpend = performance.now() - this.spinnerTime;
      if (timeSpend < 1000) {
        setTimeout(function(){
          if(spinner.classList.contains('active')){
            spinner.classList.remove('active');
          }
        },1000 - timeSpend);
      }else{
        if(spinner.classList.contains('active')){
          spinner.classList.remove('active');
        }  
      }
    }
  }

  //messages
  presentConfirm() {
    this.watchObs = false;
    let alert = this.alertCtrl.create({
      title: 'Klaar voor afhaling',
      message: 'Klik op bevestigen wanneer het product mee gegeven word.',
      buttons: [
        {
          text: 'Annuleren',
          role: 'cancel',
          handler: () => {
            this.toastHelper.showToast('Afhaling geanulleerd.');
            this.watchObs = true;
          }
        },
        {
          text: 'Bevestigen',
          handler: () => {
            this.setPickedUp(true);
            this.watchObs = true;
          }
        }
      ]
    });
    alert.present();
  }

  presentNoConnectionAlert(retryCb, cancelCb = null){
    let alert = this.alertCtrl.create({
      title: 'Geen internet',
      message: 'Kon geen verbinding maken',
      buttons: [
        {
          text: 'Annuleer',
          role: 'cancel',
          handler: () => {
            this.toastHelper.showToast('ERROR: Geen internetverbinding gevonden.', 'error');
            if (cancelCb != null) {
              cancelCb();
            }
            this.hideLoading();
          }
        },
        {
          text: 'Probeer opnieuw',
          handler: () => {
            retryCb();
          }
        }
      ]
    });
    alert.present();
  }

  showLoading(msg){
    this.watchObs = false;
    this.loading = this.loadingCtrl.create({
      content: msg
    });
    this.loading.present();
  }

  hideLoading(){
    this.watchObs = true;
    if (this.loading != null) {
      this.loading.dismiss();
    }
    this.loading = null;
  }
}



// WEBPACK FOOTER //
// ./src/pages/status-detail/status-detail.ts